/**
 * Menu script
 */
class NatAug_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuBlock = this.menuWrapper.find('.menu-block');
        this.menuItemSubmenu = this.menuBlock.find('.menu-item.menu-item-has-children');
        this.desktopViewport = window.matchMedia('(min-width: 1025px)');
        this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
    }

    initEvents() {
        this.menuItemSubmenu.append( "<span class='arrow'></span>" );

        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 80 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 80 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.desktopViewport.matches) {
            this.menuItemSubmenu.attr('aria-expanded', 'false');

            for (let i = 0; i < this.menuItemSubmenu.length; i++) {
                this.menuItemSubmenu.eq(i).on('click', e => {
                    let menuItemValue = this.menuItemSubmenu.eq(i).attr('aria-expanded');

                    this.menuItemSubmenu.attr('aria-expanded', 'false');
                    this.menuItemSubmenu.eq(i).attr('aria-expanded', 'true');

                    if (  menuItemValue === 'true' ) {
                        this.menuItemSubmenu.eq(i).attr('aria-expanded', 'false');
                    }
                });
            }
        }

        if (this.mobileViewport.matches) {
            this.initUI();
        }

        this.mobileViewport.addListener((mq) => {
            if (mq.matches) {
                this.initUI();
            } else {
                this.menuBlock.removeClass('is-showing');
                this.menuIcon.removeClass('is-active');
                $(document.body).removeClass('no-scroll');
                this.menuIcon.attr('aria-expanded', 'false');

                setTimeout(() => {
                    this.menuBlock.removeClass('is-active');
                }, 150);
            }
        });
    }

    initUI () {
        if (this.menuWrapper.attr('data-is-initialized')) {
            return;
        }

        this.menuWrapper.attr('data-is-initialized', 'true');

        setTimeout(() => {
            this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');

            this.menuSubmenuToggle.each(function(i, item) {
                $(item).on('click', function() {
                    $(item).parent().toggleClass('is-active');
                });
            });
        }, 0);

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                let menuIconValue = this.menuIcon.attr('aria-expanded');
                this.menuBlock.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                this.menuIcon.attr('aria-expanded', 'true');
                
                $(document.body).toggleClass('no-scroll');

                if ( menuIconValue === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }

                setTimeout(() => {
                    this.menuBlock.toggleClass('is-showing');
                }, 150);
            });
        }
    }
}
